/* ============================================================
   Schooner Supply — Product card swatch click → quick-view modal
   ---
   Concept's quick-view modal ALREADY swaps variant images
   correctly (click a color inside the modal → image updates).
   Earlier attempts to swap the card's <img> directly fought
   Concept's image-rendering structure and lost (commits
   46d4466, b2464ae). Owner's call: clicking a swatch on a
   collection card should open Concept's quick-view modal for
   that product — let the modal do the variant-image swap it
   already does well.

   This file: a single document-level click listener (capture
   phase) that, on swatch click, triggers the card's existing
   .quick-view__button — reusing Concept's button-driven
   modal-opener pattern (the button carries is="hover-button"
   + aria-controls pointing at the card's <quick-view>).

   Scoped to .product-card--card so promo cards
   (.product-card--promo) and other contexts are untouched.
   Document-level delegation means it survives Section
   Rendering API facet/sort grid re-renders without re-binding.
   ============================================================ */

(function () {
  'use strict';

  function setActive(card, li) {
    var siblings = card.querySelectorAll('.swatch-item.is-active');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-active');
    }
    li.classList.add('is-active');
  }

  document.addEventListener(
    'click',
    function (event) {
      // Target only swatches inside real product cards.
      var li =
        event.target.closest &&
        event.target.closest('.product-card--card .product-card__bottom .swatch-item');
      if (!li) return;

      var card = li.closest('.product-card--card');
      if (!card) return;

      var qvBtn = card.querySelector('.quick-view__button');
      // If the card has no quick-view button (theme setting off),
      // fall back to whatever the swatch link does (navigate to PDP).
      // We only intercept when quick-view is available — silent dead
      // clicks are worse than a navigation.
      if (!qvBtn) return;

      // Prevent the <a> link inside the swatch from navigating.
      event.preventDefault();
      event.stopPropagation();

      setActive(card, li);

      // Reuse Concept's modal-opener pattern by clicking the existing
      // button (it carries the aria-controls / is="hover-button"
      // wiring that Concept's JS hooks into).
      qvBtn.click();
    },
    true // useCapture — fire before Concept's <a> click handlers
  );
})();
